module.exports = __webpack_public_path__ + "img/alias.d7c0d68f.png";